import { FormValues } from 'donate/types'
import { connect } from 'formik'
import { useEffect } from 'react'

export const RecurringSelectionWatcher = connect<{}, FormValues>(({ formik: { values, setFieldValue, touched } }) => {
  useEffect(() => {
    if (touched.amount_cents) return
    setFieldValue('amount_cents', values.interval == 'monthly' ? 3500 : 8000)
    // TODO check if this ish does really not need deps
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [values.interval])

  return null
})
